import React, { Component } from 'react';
import withSizes from 'react-sizes';
import styled, { withTheme } from 'styled-components';
import _ from 'lodash';
import { Range } from 'rc-slider';

import { Row, Column } from '../grid';
import {getMapSizesToPropsCustom} from "common/utils";

const StyledRangeWrapper = styled.div`
  padding: 0 0 20px 0;
`;

const StyledSliderWrapper = styled.div`
  padding: 0 13px 0 13px;
`;

const StyledRow = styled(Row)`
  margin-top: 10px;
`;

const StyledMinValue = styled(Column)`
  color: ${({ theme }) => _.get(theme, 'colors.primary')};
  text-align: left;
  font-size: 0.9em;
  font-weight: bold;
  padding: 0;
`;

const StyledMaxValue = styled(Column)`
  color: ${({ theme }) => _.get(theme, 'colors.primary')};
  text-align: right;
  font-size: 0.9em;
  font-weight: bold;
  padding: 0;
`;

class RangeSlider extends Component {
  render() {
    const { isMD, values, step, sliderValues, theme, ...rest } = this.props;
    const settingsSection = isMD ? 'rangeSlider.' : 'rangeSlider.mobile.';
    const possibleSliderValues = [];
    _.map(values, value => {
      let floatValue = parseFloat(_.replace(value.value, ',', '.'));
      if (_.isNumber(floatValue) && !_.isNaN(floatValue)) {
        possibleSliderValues.push(floatValue);
      }
    });
    const sortedSliderValues = _.sortBy(possibleSliderValues);
    const minValue = _.first(sortedSliderValues);
    const maxValue = _.last(sortedSliderValues);
    let actualValues = sliderValues;
    if (_.isEmpty(sliderValues)) {
      actualValues = [minValue, maxValue];
    }
    const marks = {};
    if (step === null) {
      _.map(sortedSliderValues, value => {
        marks[value] = {
          style: {
            display: 'none'
          },
          label: value
        };
      });
    }
    return (
      <StyledRangeWrapper>
        <StyledSliderWrapper>
          <Range
            min={minValue}
            max={maxValue}
            defaultValue={[minValue, maxValue]}
            allowCross={false}
            marks={marks}
            step={step}
            dotStyle={{ display: 'none' }}
            value={actualValues}
            railStyle={{
              height: _.get(theme, settingsSection + 'rail.height', '7px')
            }}
            trackStyle={[
              {
                backgroundColor: _.get(theme, settingsSection + 'track.backgroundColor', '#ffffff'),
                height: _.get(theme, settingsSection + 'track.height', '7px')
              },
              {
                backgroundColor: _.get(theme, settingsSection + 'track.backgroundColor', '#ffffff'),
                height: _.get(theme, settingsSection + 'track.height', '7px')
              }
            ]}
            handleStyle={[
              {
                background: _.get(theme, settingsSection + 'handle.backgroundColor', '#afca05'),
                borderColor: _.get(theme, settingsSection + 'handle.backgroundColor', '#afca05'),
                width: _.get(theme, settingsSection + 'handle.width', '17px'),
                height: _.get(theme, settingsSection + 'handle.width', '17px')
              },
              {
                background: _.get(theme, settingsSection + 'handle.backgroundColor', '#afca05'),
                borderColor: _.get(theme, settingsSection + 'handle.backgroundColor', '#afca05'),
                width: _.get(theme, settingsSection + 'handle.width', '17px'),
                height: _.get(theme, settingsSection + 'handle.width', '17px')
              }
            ]}
            {...rest}
          />
        </StyledSliderWrapper>

        <StyledRow>
          <StyledMinValue size={{ xs: 6 }}>{actualValues[0]}</StyledMinValue>
          <StyledMaxValue size={{ xs: 6 }}>{actualValues[1]}</StyledMaxValue>
        </StyledRow>
      </StyledRangeWrapper>
    );
  }
}

export default withTheme(withSizes(getMapSizesToPropsCustom())(RangeSlider));
